import { render, staticRenderFns } from "./activityDetails.vue?vue&type=template&id=3cd84c11&scoped=true&"
import script from "./activityDetails.vue?vue&type=script&lang=js&"
export * from "./activityDetails.vue?vue&type=script&lang=js&"
import style0 from "./activityDetails.vue?vue&type=style&index=0&id=3cd84c11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd84c11",
  null
  
)

component.options.__file = "activityDetails.vue"
export default component.exports